import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from './Pages/_Layout';
import Home from './Pages/_Home';
import NotFound from './Pages/_NotFound';
import Tiring from './Pages/tiring';
import Fire from './Pages/Fire';
import Fouling from './Pages/Fouling';
import Grappling from './Pages/Grappling';
import MastDamage from './Pages/MastDamage';
import RunningAground from './Pages/RunningAground';
import MissileAttacks from './Pages/MissileAttacks';
import CloseCombat from './Pages/CloseCombat';
import Artillery from './Pages/Artillery';
import RammingAndOarRakes from './Pages/RammingAndOarRakes';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<Home />} />
					<Route path="/crew-tiring" element={<Tiring />} />
					<Route path="/fire-attacks" element={<Fire />} />
					<Route path="/fouling" element={<Fouling />} />
					<Route path="/grappling-ungrappling" element={<Grappling />} />
					<Route path="/mast-damage" element={<MastDamage />} />
					<Route path="/missile-attacks" element={<MissileAttacks />} />
					<Route path="/running-aground" element={<RunningAground />} />
					<Route path="/close-combat" element={<CloseCombat />} />
					<Route path="/artillery-hits-on-ships" element={<Artillery />} />
					<Route path="/ramming-and-oar-rake-attacks" element={<RammingAndOarRakes />} />
					<Route path="*" element={<NotFound />} />
				</Route>
			</Routes>
		</BrowserRouter>
	</React.StrictMode>
);
